// extracted by mini-css-extract-plugin
export default {"linksSection":"dJ-z"};